import { render, staticRenderFns } from "./createAccount.vue?vue&type=template&id=4b2ddaee&scoped=true&"
import script from "./createAccount.vue?vue&type=script&lang=js&"
export * from "./createAccount.vue?vue&type=script&lang=js&"
import style0 from "./createAccount.vue?vue&type=style&index=0&id=4b2ddaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ddaee",
  null
  
)

export default component.exports